var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "detail-header" }, [
    _c("div", { staticClass: "title" }, [
      _vm._v("\n      " + _vm._s(_vm.$t("COMMON_UPLOAD")) + "\n    "),
    ]),
    _c(
      "div",
      { staticClass: "guide-tip" },
      [
        _c("svg-icon", {
          attrs: {
            "icon-name": "icon-guidance",
            size: 20,
            "icon-color": "#00b8f5",
          },
        }),
      ],
      1
    ),
    _c("div", {
      staticClass: "guide-content-container",
      domProps: { innerHTML: _vm._s(_vm.$t("split_file_tip")) },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }